import { useState } from "@discovery/common-dplus/lib/hooks";
import * as M from "@discovery/prelude/lib/data/maybe";
import { Icon, Icons } from "../../atoms/icon";
import { cn } from "@discovery/classnames";
import * as styles from "./styles.css";
import { HamburgerList } from "../hamburger-list";
import { HamburgerTabletMenuList } from "../hamburger-tabletmenu";
import { menubarTablet, menubarTabletForNonPremium, } from "../../../component-creators/menu-bar";
import { Typography, Tags, HeaderVariants } from "../../atoms/typography";
import { useGlobalState } from "@discovery/common-dplus/lib/hooks";
import { _Config, _IsUserPremiumFromPartners, } from "@discovery/common-dplus/lib/state";
import { useUser } from "../../../utils/hooks";
export const HamburgerIcon = ({ onClickM = M.empty(), hamburgerFooterList, loginUrl, anonymous, isAllAccess, allAccessHandler, }) => {
    const [configM] = useGlobalState(_Config);
    const featureTogglesM = M.chain((x) => x.featureToggles, configM);
    const enableParentalLockM = M.chain((x) => x.enableParentalLock, featureTogglesM);
    const isParentalLockEnabled = M.fromMaybe(enableParentalLockM, false);
    const [onHover, setHover] = useState(false);
    const [isPremiumUserFromPartner] = useGlobalState(_IsUserPremiumFromPartners);
    const { isPremiumUser } = useUser();
    const isUserPremium = isPremiumUser || isPremiumUserFromPartner;
    const menuList = isUserPremium ? menubarTablet : menubarTabletForNonPremium;
    const allAccessHandlerSwitch = (id) => {
        allAccessHandler && allAccessHandler(id);
    };
    const handleMouseEnter = () => {
        setHover(true);
    };
    const handleMouseLeave = () => {
        setHover(false);
    };
    const ActiveBorder = !isAllAccess
        ? styles.activeBoxBorder
        : styles.deactiveBoxBorder;
    const DeactiveBorder = isAllAccess
        ? styles.deactiveBoxBorder
        : styles.activeBoxBorder;
    return (React.createElement("div", { className: styles.hamburgerContainer, onClick: M.fromMaybe(onClickM, () => { }), onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave, id: "#hamburgerBtn" },
        onHover && (React.createElement("div", { className: styles.contentListContainer, id: "#hamburgerListContainerD" },
            isParentalLockEnabled && (React.createElement("div", { className: styles.allAccessContainer },
                React.createElement("div", { className: styles.wrapper },
                    React.createElement("div", { className: cn(isAllAccess ? styles.allAccessWrapper : styles.kidsWrapper, ActiveBorder), onClick: () => allAccessHandlerSwitch("kids"), id: isAllAccess ? "kidsSafeDeactiveMode" : "kidsSafeActiveMode" },
                        React.createElement(Typography, { classNameM: M.of(isAllAccess ? styles.allAccessTitle : styles.kidsSafeText), variant: HeaderVariants.headingSix, tag: Tags.h6 },
                            React.createElement(React.Fragment, null, "Kids Safe"))),
                    React.createElement("div", { className: cn(isAllAccess ? styles.kidsWrapper : styles.allAccessWrapper, DeactiveBorder), onClick: () => allAccessHandlerSwitch("allAccess"), id: isAllAccess
                            ? "allAccessActiveMode"
                            : "allAccessDeactiveMode" },
                        React.createElement(Typography, { classNameM: M.of(isAllAccess ? styles.kidsSafeText : styles.allAccessTitle), variant: HeaderVariants.headingSix, tag: Tags.h6 },
                            React.createElement(React.Fragment, null, "All Access")))))),
            React.createElement("div", { className: styles.hamburgerMenuList },
                React.createElement("div", { className: styles.hamburgerMenuTabletList }, menuList.map((item, index) => (React.createElement(HamburgerTabletMenuList, { title: item.title, type: item.type, src: item.src, altSrc: item.altSrc, url: item.url, key: index, onClickHamburgerList: handleMouseLeave })))),
                React.createElement("div", null, hamburgerFooterList && hamburgerFooterList.length ? (hamburgerFooterList.map((item, index) => (React.createElement(HamburgerList, { key: index, titleM: item.titleM, imageSrc: item.imageSrc, route: item.route, loginUrl: loginUrl, anonymous: anonymous, alias: item.alias, onClickHamburgerList: handleMouseLeave, collectionAttributes: item.collectionAttributes })))) : (React.createElement(React.Fragment, null)))))),
        React.createElement("div", { className: styles.iconStyle },
            React.createElement(Icon, { type: Icons.Hamburger, className: styles.hamburger, color: "white" }))));
};

